import { BASE_USER_URL, BASE_URL } from '../store/apiConfig';
import { getAuthUser } from './auth.util';

export function getEmployeeFilePath(path, coCd) {
  if (!path) return null;
  const hrCoCd = coCd || getAuthUser()?.hrCoCd.trim();
  const parts = path.split(/[/\\]/);
  const fileName = parts[parts.length - 1];
  const fullPath = `${BASE_URL}${BASE_USER_URL}/cdn/${fileName}?hrCoCd=${hrCoCd}`;
  return fullPath;
}

export function pasrseEmployeeImageFileName(path) {
  if (!path) return null;
  const parts = path.split(/[/\\]/);
  const fileName = parts[parts.length - 1];
  return fileName;
}
